import React from 'react';
import {
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';

import ActionButton from '../../../components/ActionButton';

import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  paper: {
    margin: '10px 0',
    padding: '40px',
    width: '100%',
    boxSizing: 'border-box',
  },
  texts: {
    marginBottom: '20px',
  },
  sectionContainer: {
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  textfield: {
    marginLeft: '20px',
    marginRight: '20px',
    marginBottom: '12px',
    width: '320px',
  },
}));

export default function FormModificaGruppo(props) {
  const classes = useStyles();
  // A group whose costoUnitario the backend never set cannot be saved at all,
  // not even renamed: GruppoManagementService.updateGruppo refuses the request
  // while the *stored* cost is null, so the disabled button matches what the
  // API accepts rather than hiding a save that would 400.
  const submitButtonDisabled =
    props.gruppo.nome.length === 0 ||
    !props.isDirty ||
    props.costoUnitarioError.length > 0;
  return (
    <Container maxWidth="md" className={classes.container}>
      <Paper className={classes.paper}>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.sectionContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography variant="h5" className={classes.texts}>
              Dati del gruppo
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  style={{ paddingBottom: '10px' }}
                >
                  <TextField
                    label="ID gruppo"
                    id="gruppo-id"
                    name="id"
                    disabled
                    value={props.gruppo.id === null ? '' : props.gruppo.id}
                    InputProps={{
                      readOnly: true,
                    }}
                    className={classes.textfield}
                  />
                  <TextField
                    label="Nome del brand"
                    id="gruppo-brand"
                    disabled
                    // A group without a brand is a state the API accepts -
                    // createGruppo validates the brand only when one is sent -
                    // and GruppiTable already renders ' - ' for one.
                    value={props.gruppo.brand ? props.gruppo.brand.nome : ''}
                    InputProps={{
                      readOnly: true,
                    }}
                    className={classes.textfield}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Grid
                  container
                  direction="column"
                  alignItems="center"
                  style={{ paddingBottom: '10px' }}
                >
                  <TextField
                    label="Nome gruppo"
                    id="gruppo-nome"
                    name="nome"
                    value={props.gruppo.nome}
                    onChange={props.onChange}
                    className={classes.textfield}
                  />
                </Grid>
                <TextField
                  label="Costo unitario base"
                  id="gruppo-costo-unitario"
                  name="costoUnitario"
                  value={props.gruppo.costoUnitario || ''}
                  onChange={props.onCostoUnitarioChange}
                  className={classes.textfield}
                  error={props.costoUnitarioError.length > 0}
                  helperText={props.costoUnitarioError}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">€</InputAdornment>
                    ),
                  }}
                />
                <FormControl
                  component="fieldset"
                  className={classes.textfield}
                  style={{ textAlign: 'left' }}
                >
                  <FormLabel component="legend" style={{ color: 'black' }}>
                    Pagamenti gestiti da BIORSAF o via Partner
                  </FormLabel>
                  <RadioGroup
                    row
                    name="tipologiaPagamento"
                    value={props.gruppo.tipologiaPagamento || ''}
                    onChange={props.onChange}
                  >
                    <FormControlLabel
                      value="BIORSAF"
                      control={<Radio color="primary" />}
                      label="BIORSAF"
                    />
                    <FormControlLabel
                      value="PARTNER"
                      control={<Radio color="primary" />}
                      label="Partner (contratto)"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justify="flex-end">
          <Grid item>
            <ActionButton
              label="Salva modifiche"
              disabled={submitButtonDisabled}
              onClick={props.onSubmit}
              grayVersion={false}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}

FormModificaGruppo.propTypes = {
  gruppo: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onCostoUnitarioChange: PropTypes.func.isRequired,
  costoUnitarioError: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
};
